import { combineReducers} from 'redux';
//import {reducer as reduxForm} from 'redux-form';
import {authReducer} from './authReducer';
import {insOffersReducer} from './insOffersReducer';
import {insVehicleInfoReducer} from './insVehicleInfoReducer';
import {insCompaniesReducer} from './insCompaniesReducer';
import {questionsPolicyReducer} from './questionsPolicyReducer';
import {ownerDetailsPolicyReducer} from './ownerDetailsPolicyReducer';
import {userDetailsPolicyReducer} from './userDetailsPolicyReducer';
import {shipmentDetailsReducer} from './shipmentDetailsReducer';
import { paymentReducer } from './paymentReducer';
import {liabilityStepReducer} from './liabilityStepReducer';
import { newsReducer } from './newsReducer';



export default combineReducers({
    auth                : authReducer,
    insOffers           : insOffersReducer,
    insVehicleInfo      : insVehicleInfoReducer,
    insCompanies        : insCompaniesReducer,
    questionsPolicy     : questionsPolicyReducer,
    ownerDetails        : ownerDetailsPolicyReducer,
    userDetails         : userDetailsPolicyReducer,
    shipmentDetails     : shipmentDetailsReducer,
    payment             : paymentReducer,
    liabilityStep       : liabilityStepReducer,
    news                : newsReducer
//    form: reduxForm,
})

